module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/enterprise-c7fd29c9.svg";